import React, { createContext, useContext } from 'react';

export interface ScheduleFormValue {
  isEditMode: boolean;
}

const ScheduleFormContext = createContext<ScheduleFormValue>({
  isEditMode: false
});

export const ScheduleFormProvider: React.FC<{
  value?: ScheduleFormValue;
}> = ({ value, ...props }) => {
  value = {
    isEditMode: value?.isEditMode || false
  };
  return <ScheduleFormContext.Provider value={value} {...props} />;
};

export function useScheduleForm(): ScheduleFormValue {
  const context = useContext(ScheduleFormContext);
  return (
    context || {
      isEditMode: false
    }
  );
}
